<template>
<div class="container-fluid">
  <div class="row text-white bg-dark mb-2 pb-1">
    <div class="col-auto pt-2 me-auto">
      <span class="fw-bold fs-5">CONNECX</span>
      <span class="ms-2 text-secondary" style="font-size: x-small;">B{{buildTime}}</span>
      <span v-if="isTestEnv" class="text-danger font-weight-bold ms-3 fs-6">TEST ENVIRONMENT</span>
    </div>

    <template v-if="isLoggedIn()">
    <div class="col-auto mx-0 px-1">
      <button type="button" class="btn btn-secondary btn-sm mt-2 mx-0" v-b-tooltip.hover title="Dashboard">
        <router-link to="/dashboard"><i class="fa fa-tachometer-alt text-white"></i></router-link>
      </button>
    </div>
    <div class="col-auto mx-0 ps-1 pe-3">
      <button type="button" class="btn btn-secondary btn-sm mt-2 mx-0" v-b-tooltip.hover title="Transactions">
        <router-link to="/transactions"><i class="fa fa-list text-white"></i></router-link>
      </button>
    </div>
    <div class="col-auto mx-0 ps-1 pe-3">
      <button type="button" class="btn btn-secondary btn-sm mt-2 mx-0" v-b-tooltip.hover title="Balances">
        <router-link to="/balancesummary"><i class="fa fa-sack-dollar text-white"></i></router-link>
      </button>
    </div>
    <div class="col-auto dropdown mx-0 px-1">
      <button class="btn btn-secondary btn-sm dropdown-toggle mt-2 me-0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-cogs"></i>
      </button>
      <ul class="dropdown-menu py-0" aria-labelledby="dropdownMenuButton1">
        <li class="bg-info py-2 mt-0 text-white fw-bold text-center">Settings</li>
        <li v-for="item in settingsItems" :key="item.to">
          <router-link :to="item.to" class="dropdown-item">{{item.label}}</router-link>
        </li>
      </ul>
    </div>
    <div class="col-auto dropdown mx-0 px-1">
      <button class="btn btn-secondary btn-sm dropdown-toggle mt-2 ms-0" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa fa-user-circle"></i>
      </button>
      <ul class="dropdown-menu py-0" aria-labelledby="dropdownMenuButton2">
        <li class="bg-info py-2 mt-0 text-white fw-bold text-center">{{$store.state.token.userId}}</li>
        <li><router-link to="/pwchange" class="dropdown-item"><i class="fa fa-lock me-2"></i> Change Password</router-link></li>
        <li><a class="dropdown-item" href="#" @click.prevent="logout"><i class="fa fa-power-off me-2"></i>Logout</a></li>
      </ul>
    </div>
    </template>
  </div>
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
export default {
  name: 'AdminHeader',
  mixins: [HelpersMixin],
  data () {
    return {
      buildTime: process.env.VUE_APP_BUILD_TIME,
      isTestEnv: false
    }
  },
  computed: {
    settingsItems () {
      // perm omitted = always visible
      const items = [
        { to: '/merchants', label: 'Merchants' },
        { to: '/paymentchannels', label: 'Payment Channels' },
        { to: '/procbanks', label: 'Bank Codes' },
        { to: '/adminledgerentries', label: 'Admin Ledger Entries', perm: 'AX_LEDGERMAINT' },
        { to: '/referencedata', label: 'Reference Data', perm: 'AX_REFDATAMAINT' },
        { to: '/processors', label: 'Processors', perm: 'AX_PROCMAINT' },
        { to: '/adminusers', label: 'Admin Users', perm: 'AX_ADMINUSERMAINT' },
        { to: '/cacherefresh', label: 'Cache Refresh', perm: 'AX_SYSADMIN' }
      ]
      return items.filter(i => !i.perm || this.isPermitted(i.perm))
    }
  },
  mounted () {
    if (window.location.hostname.includes('localhost') || window.location.hostname.includes('test')) {
      this.isTestEnv = true
    }
  },
  methods: {
    isLoggedIn: function () {
      if (this.$store.state.token && this.$store.state.token.tokenId) {
        return true
      } else {
        return false
      }
    },
    logout: function () {
      this.axios.get('/ax/logout')
      .then(() => {
        this.$store.commit('clearToken')
        this.$router.push('/login')
      })
      .catch(error => {
        this.handleError(error)
      })
    }
  }
}
</script>

<style scoped>
.dropdown-item { font-size: .8em; border-top: 1px solid #d3d3d3; padding-top: .8em; padding-bottom: .8em;}
</style>

